import {
    MANUFACTURER_CREATE_EDIT_OPEN_MODAL,
    MANUFACTURER_CREATE_REQUEST,
    MANUFACTURER_CREATE_RESULT,
    MANUFACTURER_EDIT_REQUEST,
    MANUFACTURER_EDIT_RESULT,
    MANUFACTURER_GET_REQUEST,
    MANUFACTURER_GET_RESULT,
} from 'Redux/actionTypes';

export const manufacturerCreateEditOpenModal = (open, man) => ({
    type: MANUFACTURER_CREATE_EDIT_OPEN_MODAL,
    payload: { open, man }
})

export const manufacturerCreateRequest = (data) => ({
    type: MANUFACTURER_CREATE_REQUEST,
    payload: data
})

export const manufacturerCreateResult = (result) => ({
    type: MANUFACTURER_CREATE_RESULT,
    payload: result
})

export const manufacturerEditRequest = (data) => ({
    type: MANUFACTURER_EDIT_REQUEST,
    payload: data
})

export const manufacturerEditResult = (result) => ({
    type: MANUFACTURER_EDIT_RESULT,
    payload: result
})

export const manufacturerGetRequest = (data) => ({
    type: MANUFACTURER_GET_REQUEST,
    payload: data
})

export const manufacturerGetResult = (result) => ({
    type: MANUFACTURER_GET_RESULT,
    payload: result
})